// Don't apply 'HeadingBuilder' for this component's 'Tippy contents' (table data)
import React, { useState, useContext } from 'react';
import { ShopperContext } from '../context/shopper'
import * as Constants from '../constants'
import { showRoundedAbsAmt, findAbsAmtAsPct,
          absAmtAsPctEvenIfWeighty } from '../utils';
import { useStyles } from "../hooks/useStyles";
import { useFormats, usePricing } from "../hooks/useSkuUtils";
import { useOrderItemChangeHandlers } from "../hooks/useUtils";
import { InputDynamicText } from '../components/InputDynamicText';
import { OutlayAmt } from '../components/OutlayAmt';
import { useTranslation } from "react-i18next";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { NumericFormat } from 'react-number-format';
import styled from 'styled-components';
const Button = styled.button`
  /* Adapt the colors based on primary prop */
  background: ${props => props.primary ? Constants.O_BOX_GREEN : Constants.O_BOX_PINK};
  border: none;
  &.hover {
    background: #e7e7e7; color: black;
    transition: 0.3s;
  }
`;

// We have already verified "if_shopper_is_circle_admin", so don't need to check.
// Can't be abused because backend verifies that only the shopper or admin is updating.
//
// When showing other shoppers' orders on the ShoppingList page as an admin,
// this component builds out a line of another shopper's orderItem. It includes
// input boxes for changing the order quantity of the other shopper's orderItem.
// Non-admins will use a different component that won't show input boxes for qty
export const AdminChangeOtherOrder = ({
    isForOoTable = false,
    order,
    trip,
    sku,
    actualWeight,
    skuPrice
   }) => {
  console.log("acooC skuPrice", skuPrice)
  const { orderItems, changeOrderItem, showOutlayWithTax,
          showSlimShopList,
        } = useContext(ShopperContext);
  console.log("ooD orderItems", orderItems)
  const { t } = useTranslation();
  const { editBoxStyle, textAlignRight } = useStyles();
  const { checkDecimalInput,
          spaceUnits,
        } = useFormats();
  const { chooseDecimalScaleQty,
        } = usePricing();
  const { handleMinMaxNoteClick } = useOrderItemChangeHandlers();

  const isMultipack = sku.type == "MultipackItem" ? true : false;
  const isSingular =  sku.type == "SingularItem" ? true : false;
  const isWeighty  =  sku.type == "WeightyItem" ? true : false;

  const [orderAmtButtonIsPink, setOrderAmtButtonIsPink] = useState(false);
  const [plusButtonIsGreen, setPlusButtonIsGreen] = useState(true);
  const [unitQty, setUnitQty] = useState(
    isSingular
          ? 0
          : Math.round(order.abs_amount * 100)/100
  );
  console.log("oief unitQty", unitQty);

  const [absAmtAsPct, setAbsAmtAsPct] = useState(
    findAbsAmtAsPct({topNum: order.abs_amount, sku})
  );
  console.log("oief absAmtAsPct", absAmtAsPct);

  const handleClick = (e) => {
    setOrderAmtButtonIsPink(false);
    setPlusButtonIsGreen(true);
    console.log("oief hc sku1", order);
    console.log("oief hc sku1.5", order.id);
    console.log("oief hc sku2", e.target.value);
    const orderItem = {
      abs_amount: isSingular ? (parseFloat(absAmtAsPct) / 100) : unitQty
    };
    changeOrderItem(orderItem, order.id);
  }

  const handleOIUnitQtyChange = (e) => {
    const newUnitQty = checkDecimalInput( {numInput: e.target.value} )

    setOrderAmtButtonIsPink(true);
    setPlusButtonIsGreen(false);
    console.log("hoiuqc plusButtonIsGreen", plusButtonIsGreen);
    console.log("hoiuqc nuq", newUnitQty);
    setUnitQty(() => newUnitQty);
    if (isMultipack || isWeighty) {
      setAbsAmtAsPct( () => findAbsAmtAsPct({topNum: newUnitQty, sku}) )
    }
  }

  const handleOIAbsAmtAsPctChange = (e) => {
    const newAbsAmtAsPct = checkDecimalInput( {numInput: e.target.value} )

    setOrderAmtButtonIsPink(true);
    setPlusButtonIsGreen(false);
    console.log("hoiaqapc plusButtonIsGreen", plusButtonIsGreen);
    console.log("oief aqap1", absAmtAsPct);
    console.log("oief hoiaqapc naqap", newAbsAmtAsPct);
    setAbsAmtAsPct( () => newAbsAmtAsPct )
    console.log("oief aqap2", absAmtAsPct);
  }

    const adjustedAbsAmtAsPct =
                    absAmtAsPctEvenIfWeighty({absAmtAsPct, sku, actualWeight});

    return (
      <>
    {/* When we consider showing Admin tools for changing others' orders, the
        context is important. With the normal table showing full rows of
        OrderItem info, invoking this Admin component with isForOoTable={false}
        guides the output to display in normal Shopping List rows.
        'showSlimShopList' says to show far fewer columns in the Shopping List.
        Admins, like everyone else, can set 'showSlimShopList' to 'true'.
        If it is true, then the last column will be a 'details' button, which
        invokes seeing all of a sku's data via an 'OrderItemTable'.
        If 'showOthersOrders' is true then the shopper wants to see either full
        rows of Others' Orders in a normal Shopping List way or else the small
        'OthersOrdersTable' below the 'OrderItemTable'. The 'OthersOrdersTable'
        component invokes this Admin component with isForOoTable={true}. In this
        context, the Admin component knows to show a table with short rows.
        The 'showOthersOrders' setting acts as a filter that, when true, lets
        rows of others' order info come through for display.
        When it is false, there are no rows for this component to display.
     */}
    {(showSlimShopList  &&  !isForOoTable)  // if list is slim and no OOTable:
    ? null
    : <>
      {/* If 'isForOoTable', then our table has data about only one sku.
          If that sku is singular, it will only have a (useless) value of '--'
          for 'UnitQty'. Since this is irrelevant, why show it if don't have to?
          In the big table of all skus/orderItems for the trip, we are stuck
          with showing values of '--' for singular skus. That is, we can't
          just hide the column since we need to see the 'UnitQty' values of
          weighty and multipack skus.
       */}
      {(isForOoTable  &&  sku.type === 'SingularItem')
      ? null
      :
      <td>
        {/* "UnitQty" */}
        {
          (isMultipack || isWeighty)
            ? <span><NumericFormat displayType="input"
                type="text"
                name="unitQty"
                onChange={e => handleOIUnitQtyChange(e)}
                onKeyUp={e => {
                  if (e.key === 'Enter') {
                    handleClick(e)
                  }
                }}
                value={unitQty}
                decimalScale={ chooseDecimalScaleQty({sku}) }
                style={ editBoxStyle({ cellQty: unitQty,
                  changeColorOfBox: orderAmtButtonIsPink,
                  normalBoxColor:   Constants.O_BOX_YELLOW,
                  editBoxColor:     Constants.O_BOX_PINK
                }) }
              /></span>
            : <>--</>
        }

        { isWeighty  &&  spaceUnits({units: sku.units}) }
      </td>
      }

  { isForOoTable
    ? null
    :
      <td>
        {/* "Unit Cost" - only the main order needs to show this */}
      </td>
  }
    </>
    }

      <td style={textAlignRight}>
        {/* "%Wantd" */}
        {
          (isSingular && (isForOoTable  ||  !showSlimShopList))
            ? <span><NumericFormat displayType="input"
                type="text"
                name="absAmtAsPct"
                onChange={e => handleOIAbsAmtAsPctChange(e)}
                onKeyUp={e => {
                  if (e.key === 'Enter') {
                    handleClick(e)
                  }
                }}
                value={absAmtAsPct}
                decimalScale={ chooseDecimalScaleQty({sku}) }
                style={ editBoxStyle({ cellQty: absAmtAsPct,
                  changeColorOfBox: orderAmtButtonIsPink,
                  normalBoxColor:   Constants.O_BOX_YELLOW,
                  editBoxColor:     Constants.O_BOX_PINK
                }) }
              />%</span>
            : <>{showRoundedAbsAmt({ adjustedAbsAmtAsPct }) + "%"}</>
        }
      </td>

{ // #-#
  isForOoTable
    ? <td>
        <InputDynamicText
          initialText={order.min_max_note || ''}
          handleTextClick={handleMinMaxNoteClick(order.id)}
          placeholder=''
          rows={5}
          cols={26}
          checkboxPosition={"side"}
        />
      </td>
    : showSlimShopList
      ? null
      : <td>
          <InputDynamicText
            initialText={order.min_max_note || ''}
            handleTextClick={handleMinMaxNoteClick(order.id)}
            placeholder=''
          />
        </td>
}

      {/* If 'showSlimShopList' is true, then don't show the Outlay column in
          the main row. But,
          if we are populating the 'OrderItemTable', then ok, show outlay.
      */}
{(showSlimShopList  &&  !isForOoTable)
    ? null
    : <>
      <td>
       <div className = "oneline-container-right">
        <OutlayAmt
          trip        = {trip}
          sku         = {sku}
          sku_price   = {skuPrice}
          order       = {order}
          decimal_amt = {absAmtAsPct / 100}
          showOutlayWithTax = {showOutlayWithTax}
        />
       </div>
      </td>

  {/* Don't show the 'O' element in 'OthersOrdersTable'.
      But do show it in 'OrderItem' and 'OrderItemTable'.
      Also, 'OrderItemTable' will show it via 'orderData.o'.
  */}
  {isForOoTable
    ? null
    :
      <td>
        {/* "O" button: */}
  {/* <Tippy content='Click the pink "O" sign (or press Enter) to update the database with the amount the shopper wants of the product. It will turn back to green upon successful update.'> */}
  <Tippy content= {t('orderItem.o_col.tippyContent', {
    character: Constants.O_COL_SYM,
    whoWantsPhrase: t('adminChangeOtherOrder.o_col.shopperWants')
  })} >
    <Button type="button" primary={plusButtonIsGreen} value={order.id} onClick={handleClick}>{Constants.O_COL_SYM}</Button>
  </Tippy>
      </td>
  }

    </>
}

    </>
  )

};
      
export default AdminChangeOtherOrder;